<template>
  <div>
    <v-container fluid>
      <v-card class="card2" style="margin-top: 1rem">
        <div class="header-section">
          <!-- Document Name Showcase -->
          <div class="document-showcase">
            <div class="document-header">
              <div class="document-info">
                <div class="d-flex align-center flex-wrap" style="gap: 12px;">
                  <h2 class="document-name">
                    {{ documentName || $t('_noDocumentSelected') }}
                  </h2>
                  <v-chip
                    v-if="processingStatus"
                    :color="processingStatus.isDone ? 'success' : 'warning'"
                    variant="flat"
                    size="default"
                    class="processing-chip"
                    :class="{ 'processing-chip--active': !processingStatus.isDone }"
                  >
                    <v-icon start size="16" :class="{ 'mdi-spin': !processingStatus.isDone }">
                      {{ processingStatus.isDone ? 'mdi-check-circle-outline' : 'mdi-loading' }}
                    </v-icon>
                    <span v-if="!processingStatus.isDone">
                      {{ $t('processing') }} &nbsp;<strong>{{ processingStatus.inProcess }}/{{ processingStatus.processFinish }}</strong>
                    </span>
                    <span v-else>&#10004;&nbsp;{{ $t('_successfullyProcessed') }}</span>
                  </v-chip>
                </div>
              </div>

              <div class="toggle-section">
                <v-switch
                  v-model="CheckboxShowAllText"
                  color="primary"
                  hide-details
                  density="compact"
                  inset
                  :class="['publication-toggle', CheckboxShowAllText ? 'publication-toggle--active compact-toggle--active' : 'publication-toggle--inactive']"
                  class="compact-toggle publication-toggle"
                >
                  <template #label>
                    <div class="toggle-label">
                      <span style="font-size: 1rem">{{ $t('_ShowAllText') }}</span>
                    </div>
                  </template>
                </v-switch>
              </div>

              <v-btn id="button-add-uploadsoundtodocumentdetail" color="success" variant="flat" @click="Add()" class="create-btn custombtn">
                <v-icon start size="18">mdi-plus</v-icon>
                {{ $t('add') }}
              </v-btn>
            </div>
          </div>
        </div>

        <v-flex class="flex">
          <v-data-table-server
            v-model:options="options"
            :items-per-page="options.itemsPerPage"
            :loading="loading"
            :items-length="speechDocumentDataDetail.total"
            :items="speechDocumentDataDetail.data"
            :headers="headers"
            class="px-5"
          >
            <template v-slot:item="{ item }">
              <tr class="table-row">
                <td class="number-cell">
                  {{ item.number }}
                </td>

                <td class="text-cell">
                  <div class="text-container">
                    <div class="text-content-wrapper">
                      <span :class="[item.show ? 'text-content-show' : 'text-content']" v-html="formatText(item.originalText)"></span>
                    </div>
                  </div>
                </td>

                <td class="text-cell">
                  <div class="text-container">
                    <div class="text-content-wrapper">
                      <span :class="[item.show ? 'text-content-show' : 'text-content']" v-html="formatText(item.summarizedText)" :style="getStyle(item.summarizedText)"></span>
                    </div>
                    <v-btn icon variant="text" size="small" color="#C32E0E" @click="item.show = !item.show" class="expand-btn">
                      <v-icon size="20" color="#C32E0E" :color="item.show ? 'primary' : 'grey'">
                        {{ item.show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                      </v-icon>
                      <v-tooltip activator="parent" location="top">
                        {{ item.show ? $t('collapse') : $t('expand') }}
                      </v-tooltip>
                    </v-btn>
                  </div>
                </td>

                <td class="action-cell">
                  <div class="action-container">
                    <div class="action-group">
                      <!-- Import Button -->
                      <v-btn id="button-importdocument-popupimportdocument-uploadsoundtodocumentdetail" variant="text" density="comfortable" @click="ImportDocument(item)" class="importbtn">
                        <v-img :src="images.importImg" alt="Import" style="width: 20px; height: 20px" />
                        {{ $t('import') }}
                        <v-tooltip width="250" activator="parent" location="top"> {{ $t('_InfoImportToMemory') }} </v-tooltip>
                      </v-btn>
                      <!-- Edit Button -->
                      <v-btn
                        id="button-edit-popupedit-uploadsoundtodocumentdetail"
                        variant="text"
                        density="comfortable"
                        @click="EditSpeechDocumentDetail(item)"
                        class="action-btn edit-btn"
                        icon
                        size="small"
                      >
                        <img :src="images.edit" alt="Edit" style="width: 25px; height: 25px" />
                        <v-tooltip activator="parent" location="top">{{ $t('edit') }}</v-tooltip>
                      </v-btn>
                      <!-- Summarize Button -->
                      <v-btn
                        id="button-summarized-popupsummarized-uploadsoundtodocumentdetail"
                        variant="text"
                        density="comfortable"
                        @click="SummarizedPopup(item)"
                        class="action-btn summarize-btn"
                        icon
                        size="small"
                      >
                        <v-icon size="18">mdi-auto-fix</v-icon>
                        <v-tooltip activator="parent" location="top" width="230"> {{ $t('_InfoSummarizeTooltip') }} </v-tooltip>
                      </v-btn>
                      <!-- Delete Button -->
                      <v-btn id="button-delete-uploadsoundtodocumentdetail" variant="text" density="comfortable" @click="DeleteById(item.id)" class="action-btn delete-btn" icon size="small">
                        <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px" />
                        <v-tooltip activator="parent" location="top">{{ $t('delete') }}</v-tooltip>
                      </v-btn>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
            <template v-slot:bottom>
              <v-card-actions class="justify-end pa-4">
                <v-btn id="button-close-uploadsoundtodocumentdetail" variant="text" color="#C32E0E" class="close-all-btn" to="/UploadSoundToDocument"> {{ $t('closeAll') }} </v-btn>
              </v-card-actions>
              <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                <div>{{ $t('totalResults') }} {{ speechDocumentDataDetail.total }}</div>

                <v-data-table-footer
                  :items-per-page-options="[10, 20, 50]"
                  v-model:items-per-page="itemsPerPage"
                  :page="options.page"
                  :length="Math.ceil(speechDocumentDataDetail.total / itemsPerPage)"
                />
              </div>
            </template>
          </v-data-table-server>
        </v-flex>
      </v-card>
    </v-container>

    <!--Upload popup-->
    <v-container fluid>
      <v-dialog v-model="uploadDialog" max-width="900px" persistent transition="dialog-bottom-transition" class="modern-dialog">
        <v-card class="dialog-card">
          <!-- Dialog Header -->
          <v-card-title class="dialog-header dialog-header-add">
            <div class="header-main">
              <div class="header-text">
                <h2 class="dialog-title">{{ $t('_uploadSpeechFiles') }}</h2>
                <p class="dialog-subtitle">{{ $t('_uploadSpeechFilesSubtitle') }}</p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn icon variant="text" @click="uploadDialog = false" class="close-btn">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>

          <v-divider></v-divider>

          <!-- Dialog Content -->
          <v-card-text class="dialog-content">
            <!-- Document Name and Language Row -->
            <v-row>
              <v-col cols="12" md="8">
                <div class="input-group">
                  <label class="input-label" for="transcriptionname-field-uploadsoundtodocumentdetail">{{ $t('transcriptionName') }} <span style="color: red">*</span></label>
                  <v-text-field id="transcriptionname-field-uploadsoundtodocumentdetail" v-model="documentName" :rules="[rules.required]" required variant="outlined" hide-details="auto" class="modern-input" color="primary"> </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="input-group">
                  <label class="input-label" for="language-autocomplete-uploadsoundtodocumentdetail">{{ $t('language') }} <span style="color: red">*</span></label>
                  <v-select
                    id="language-autocomplete-uploadsoundtodocumentdetail"
                    :items="langaugeType"
                    item-title="name"
                    item-value="value"
                    v-model="request.langPop"
                    variant="outlined"
                    hide-details
                    class="modern-input"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'language-uploadsoundtodocumentdetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template #prepend-inner>
                      <v-img :src="images.langImg" alt="Language" style="width: 20px; height: 20px" />
                    </template>
                  </v-select>
                </div>
              </v-col>
            </v-row>

            <!-- AI Model and Bot Summation Row -->
            <v-row class="mb-2">
              <v-col cols="12" md="4" class="d-flex align-center">
                <v-switch
                  id="botsummation-checkbox-uploadsoundtodocumentdetail"
                  v-model="botSummation"
                  color="primary"
                  hide-details
                  density="compact"
                  inset
                  class="inline-switch mt-4"
                  :class="['publication-toggle', botSummation ? 'publication-toggle--active' : 'publication-toggle--inactive', botSummation ? 'inline-switch-active' : 'inline-switch']"
                >
                  <template #label>
                    <div class="inline-label">
                      <span class="mr-2">{{ $t('aiSummarization') }}</span>
                    </div>
                  </template>
                </v-switch>
              </v-col>
              <v-col cols="12" md="8">
                <div class="input-group">
                  <label class="input-label" for="aimodel-select-uploadsoundtodocumentdetail">{{ $t('aiModelForSummarization') }} <span style="color: red">*</span></label>
                  <v-select
                    id="aimodel-select-uploadsoundtodocumentdetail"
                    :items="listDDModelDisplayName"
                    :item-title="getItemModelNameText"
                    :item-value="getItemModelNameID"
                    :disabled="!botSummation"
                    v-model="modelDisplayID"
                    variant="outlined"
                    clearable
                    hide-details
                    :placeholder="$t('_selectAiModelForSummation')"
                    class="modern-input"
                    :class="{ 'input-disabled': !botSummation }"
                    :rules="[(v) => !!v || $t('requiredField')]"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'aimodel-uploadsoundtodocumentdetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.modelDisplayID }}: {{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                  </v-select>
                </div>
              </v-col>
            </v-row>

            <!-- File Upload Area -->
            <div class="upload-section">
              <v-card variant="outlined" class="upload-area-card" :class="{ 'drag-over': isDragOver }">
                <MultipleDragAndDrop
                  :dialog.sync="uploadDialog"
                  :multiple="true"
                  @filesUploaded="processUpload($event)"
                  @dragover="isDragOver = true"
                  @dragleave="isDragOver = false"
                  @drop="isDragOver = false"
                />
              </v-card>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Dialog Actions -->
          <v-card-actions class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn variant="outlined" color="grey" @click="uploadDialog = false" class="dialog-action-btn cancel-btn"> {{ $t('cancel') }} </v-btn>

                <v-btn
                  id="button-save-popupupload-uploadsoundtodocumentdetail"
                  variant="flat"
                  @click="Save()"
                  :loading="loading"
                  class="dialog-action-btn save-btn-add"
                  :disabled="!documentName || !request.filesList"
                >
                  <v-img :src="images.uploadImg" alt="Upload" style="width: 20px; height: 20px" class="mr-2" />
                  {{ $t('uploadFiles') }}
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <!--Edit popup-->
    <v-container fluid>
      <v-dialog v-model="editDialog" max-width="900px" persistent transition="dialog-bottom-transition" class="modern-dialog">
        <v-card class="dialog-card">
          <!-- Dialog Header -->
          <v-card-title class="dialog-header dialog-header-edit">
            <div class="header-main">
              <div class="header-text">
                <h2 class="dialog-title">{{ $t('_editTextSummary') }}</h2>
                <p class="dialog-subtitle">{{ $t('_editTextSummarySubtitle') }}</p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn icon variant="text" @click="editDialog = false" class="close-btn">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>

          <v-divider></v-divider>

          <!-- Dialog Content -->
          <v-card-text class="dialog-content">
            <v-row>
              <v-col cols="12" md="6">
                <div class="input-group">
                  <label class="input-label" for="originaltext-textarea-edit-uploadsoundtodocumentdetail">{{ $t('originalText') }} <span style="color: red">*</span></label>
                  <v-textarea v-model="edit.originalText" id="originaltext-textarea-edit-uploadsoundtodocumentdetail" variant="outlined" rows="8" hide-details="auto" class="modern-input">
                  </v-textarea>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="input-group">
                  <label class="input-label" for="summarizedtext-textarea-edit-uploadsoundtodocumentdetail">{{ $t('summarizedText') }}</label>
                  <v-textarea v-model="edit.summarizedText" id="summarizedtext-textarea-edit-uploadsoundtodocumentdetail" variant="outlined" rows="8" hide-details="auto" class="modern-input">
                  </v-textarea>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Dialog Actions -->
          <v-card-actions class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn variant="outlined" color="grey" @click="editDialog = false" class="dialog-action-btn cancel-btn"> {{ $t('cancel') }} </v-btn>

                <v-btn id="button-editsave-popupedit-uploadsoundtodocumentdetail" variant="flat" @click="EditSave()" class="dialog-action-btn save-btn-edit">
                  <v-img :src="images.saveImg" width="20" height="20" class="mr-2" />
                  {{ $t('saveChanges') }}
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!--Import popup-->
    <v-container fluid>
      <v-dialog v-model="importDocPopup" max-width="700px" persistent transition="dialog-bottom-transition" class="modern-dialog">
        <v-card class="dialog-card">
          <v-card-title class="dialog-header dialog-header-edit">
            <div class="header-main">
              <div class="header-text">
                <h2 class="dialog-title">{{ $t('_importToKnowledgeDocument') }}</h2>
                <p class="dialog-subtitle">{{ $t('_importToKnowledgeSubtitle') }}</p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn icon variant="text" @click="importDocPopup = false" class="close-btn">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>
          <v-divider></v-divider>

          <!-- Dialog Content -->
          <v-card-text class="dialog-content">
            <v-row class="">
              <v-col cols="12" md="8">
                <div class="input-group">
                  <label class="input-label" for="docname-autocomplete-popupimport-uploadsoundtodocumentdetail">{{ $t('_chooseExistingDocument') }} <span style="color: red">*</span></label>
                  <v-select
                    id="docname-autocomplete-popupimport-uploadsoundtodocumentdetail"
                    :items="listDDLVector"
                    :item-title="getDocName"
                    :item-value="getDocId"
                    v-model="DocId"
                    :rules="[rules.required]"
                    variant="outlined"
                    clearable
                    hide-details="auto"
                    :placeholder="$t('_chooseKnowledgeDocument')"
                    class="modern-input"
                    color="primary"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'docname-uploadsoundtodocumentdetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                  </v-select>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="input-group">
                  <label class="input-label" for="maxcharacter-field-uploadsoundtodocumentdetail">{{ $t('maxCharacterPerChunk') }} <span style="color: red">*</span></label>
                  <v-text-field
                    id="maxcharacter-field-uploadsoundtodocumentdetail"
                    v-model="maxLimitedCharacter"
                    placeholder="5000"
                    :rules="[rules.required]"
                    variant="outlined"
                    hide-details="auto"
                    class="modern-input number-input-custom"
                    color="#3859D0"
                  >
                    <template #prepend-inner>
                      <v-icon color="#3859D0" size="20" style="opacity: 1">mdi-format-text</v-icon>
                    </template>

                    <template #append-inner>
                      <div class="number-controls-wrapper">
                        <!-- Clear button -->
                        <v-btn v-if="maxLimitedCharacter" icon variant="text" size="small" class="clear-btn-custom" @click="clearValue">
                          <v-icon size="16" color="white">mdi-close</v-icon>
                        </v-btn>
                        <!-- Up/Down arrows with custom color -->
                        <div class="number-arrows">
                          <v-btn icon variant="text" size="x-small" class="number-arrow-btn arrow-up" @click="incrementValue">
                            <v-icon size="25" color="#3859D0">mdi-menu-up</v-icon>
                          </v-btn>
                          <v-btn icon variant="text" size="x-small" class="number-arrow-btn arrow-down" @click="decrementValue">
                            <v-icon size="25" color="#3859D0">mdi-menu-down</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </template>
                  </v-text-field>
                </div>
              </v-col>
            </v-row>

            <div class="info-card">
              <v-icon class="mr-2">mdi-information-outline</v-icon>
              <div>{{ $t('_InfoProcessSplitContent') }}</div>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Dialog Actions -->
          <v-card-actions class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn variant="outlined" color="grey" @click="importDocPopup = false" class="dialog-action-btn cancel-btn"> {{ $t('cancel') }} </v-btn>
                <v-btn
                  id="button-upload-popupimport-uploadsoundtodocumentdetail"
                  variant="flat"
                  @click="SaveImport"
                  :loading="loading"
                  class="dialog-action-btn save-btn-edit"
                  :disabled="!DocId || !maxLimitedCharacter"
                >
                  <v-img :src="images.importrightImg" width="20" height="20" class="mr-2"></v-img>
                  {{ $t('import') }}
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <!--Summarized popup-->
    <v-container fluid>
      <v-dialog v-model="SummarizedPreparePopup" max-width="600px" persistent transition="dialog-bottom-transition" class="modern-dialog">
        <v-card class="dialog-card">
          <!-- Dialog Header -->
          <v-card-title class="dialog-header dialog-header-edit">
            <div class="header-main">
              <div class="header-text">
                <h2 class="dialog-title">{{ $t('_summarizeThisText') }}</h2>
                <p class="dialog-subtitle">{{ $t('_summarizeThisTextSubtitle') }}</p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn icon variant="text" @click="SummarizedPreparePopup = false" class="close-button">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>

          <v-divider></v-divider>

          <!-- Dialog Content -->
          <v-card-text class="dialog-content">
            <div class="input-group">
              <label for="summarizedtext-autocomplete-uploadsoundtodocumentdetail">{{ $t('aiModelForSummarization') }} <span style="color: red">*</span></label>
              <v-select
                id="summarizedtext-autocomplete-uploadsoundtodocumentdetail"
                :items="listDDModelDisplayName"
                :item-title="getItemModelNameText"
                :item-value="getItemModelNameID"
                :rules="[rules.required]"
                v-model="SummarizedRow.modelDisplayID"
                variant="outlined"
                clearable
                hide-details="auto"
                :placeholder="$t('_selectAiModelToSummarize')"
                class="modern-input"
                color="primary"
              >
                <template v-slot:item="{ props, item, index }">
                  <v-list-item v-bind="props" :id="'summarizedtext-uploadsoundtodocumentdetail-option-' + index" :value="item.raw.name">
                    <template v-slot:title>
                      <span>{{ item.raw.modelDisplayID }}: {{ item.raw.name }}</span>
                    </template>
                  </v-list-item>
                </template>
              </v-select>
            </div>

            <div class="info-card mt-4">
              <v-icon class="mr-2">mdi-information-outline</v-icon>
              <div>
                {{ $t('_InfoAiModelAnalyze') }}
              </div>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Dialog Actions -->
          <div class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn variant="outlined" color="grey" @click="SummarizedPreparePopup = false" class="cancel-btn dialog-action-btn">
                  {{ $t('cancel') }}
                </v-btn>

                <v-btn
                  id="button-summarized-uploadsoundtodocumentdetail"
                  variant="flat"
                  @click="SummarizedDetail()"
                  :loading="loading"
                  class="dialog-action-btn save-btn-edit"
                  :disabled="!SummarizedRow.modelDisplayID"
                >
                  <v-img :src="images.uploadImg" alt="Upload" style="width: 20px; height: 20px" class="mr-2" />
                  {{ $t('generateSummary') }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </v-container>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">{{ $t('_deleteChunk') }}</span>
          <v-btn icon variant="text" size="small" class="delete-close-icon" @click="cancelDelete">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteItem"> {{ $t('_confirmDeleteChunk') }} </span>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn class="delete-cancel-btn" @click="cancelDelete"> {{ $t('cancel') }} </v-btn>
          <v-btn class="delete-confirm-btn" @click="confirmDelete">
            <v-img :src="images.deleteIcon" width="20" height="20" class="mr-1"></v-img>
            {{ $t('delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Loading bar-->>
    <v-overlay :value="loading">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          {{ $t('_loadingPleaseWait') }}
          <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import MultipleDragAndDrop from '@/components/MultipleDragAndDrop.vue';
import editImg from '@/assets/Icons/Edit.png';
import deleteImg from '@/assets/Icons/Delete.png';
import deleteIcon from '@/assets/images/trash-solid.svg';
import importImg from '@/assets/Icons/file-import.png';
import langImg from '@/assets/Icons/language.png';
import uploadImg from '@/assets/images/uploadwhite.png';
import importrightImg from '@/assets/images/file-import.png';
import saveImg from '@/assets/images/savecard.png';
export default {
  name: 'UploadSoundToDocumentDetail',
  components: { MultipleDragAndDrop },
  computed: {
    documentId() {
      return this.$route.query.id || '';
    },
    headers() {
      return [
        {
          title: this.$t('no'),
          align: 'center',
          value: 'number',
          sortable: false,
          width: '10%',
        },
        {
          title: this.$t('originalText'),
          align: 'start',
          value: 'originalText',
          sortable: false,
          width: '40%',
        },
        {
          title: this.$t('summarizedText'),
          align: 'center',
          value: 'summarizedText',
          sortable: false,
          width: '40%',
        },
        { title: this.$t('manage'), align: 'center', sortable: false, width: '10%' },
      ];
    },
  },
  inject: ['FontColorTitle', 'SubNavbarBackGround'],
  data() {
    return {
      allowOptionWatch: true,
      uploadDialog: false,
      editDialog: false,
      processingDocId: null,
      pollingInterval: null,
      processingStatus: null,
      itemsPerPage: 10,
      dataName: '',
      documentName: '',
      ShowAllText: false,
      CheckboxShowAllText: false,
      dialog_delete: false,
      deleteItem: null,
      today: null,
      searchDocName: '',
      langauge: ['TH', 'EN'],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      Axios_ControllerAduio: null,
      loading: false,
      modelDisplayID: 0,
      DocId: 0,
      maxLimitedCharacter: 5000,
      importDocPopup: false,
      queryImport: 0,
      ImportData: '',
      listDDLVector: [],
      SummarizedPreparePopup: false,
      langaugeType: [
        { name: 'TH', value: 'th-TH' },
        { name: 'EN', value: 'en-US' },
      ],
      listDDModelDisplayName: [],
      modelDisplay: null,
      botSummation: false,
      images: {
        edit: editImg,
        delete: deleteImg,
        deleteIcon: deleteIcon,
        importImg: importImg,
        langImg: langImg,
        uploadImg: uploadImg,
        importrightImg: importrightImg,
        saveImg: saveImg,
      },
      rules: {
        required: (value) => !!value || this.$t('requiredField'),
      },
      request: {
        dataName: '',
        filesList: [],
        langPop: 'th-TH',
      },
      LangPop: 'th-TH',
      speechDocumentDataDetail: {
        total: 0,
        sortDesc: false,
        sortBy: false,
        data: [],
      },
      speechDocumentData: {
        total: 0,
        sortDesc: false,
        sortBy: false,
        data: [],
      },
      edit: {
        id: 0,
        originalText: '',
        summarizedText: '',
      },
      SummarizedRow: {
        id: 0,
        originalText: null,
        summarizedText: null,
        modelDisplayID: 0,
      },
    };
  },
  watch: {
    options: {
      handler() {
        if (this.allowOptionWatch) {
          this.GetSpeechDocumentDetail();
        }
      },
      deep: true,
    },
    CheckboxShowAllText(newVal) {
      if (newVal) {
        this.ShowAll();
      } else {
        this.CloseShowAll();
      }
    },
  },
  methods: {
    ShowAll() {
      this.ShowAllText = !this.ShowAllText;
      this.speechDocumentDataDetail.data.forEach((element) => {
        element.show = this.ShowAllText;
      });
    },
    CloseShowAll() {
      this.ShowAllText = !this.ShowAllText;
      this.speechDocumentDataDetail.data.forEach((element) => {
        element.show = this.ShowAllText;
      });
    },
    incrementValue() {
      const currentValue = Number.parseInt(this.maxLimitedCharacter) || 0;
      this.maxLimitedCharacter = currentValue + 1; // Increment by 100
    },

    decrementValue() {
      const currentValue = Number.parseInt(this.maxLimitedCharacter) || 0;
      if (currentValue > 100) {
        this.maxLimitedCharacter = currentValue - 1; // Decrement by 100
      }
    },

    clearValue() {
      this.maxLimitedCharacter = '';
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; // January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    Add() {
      this.uploadDialog = true;
    },
    processUpload(files) {
      const validFiles = [];
      for (const file of files) {
        validFiles.push(file);
      }
      this.request.filesList = validFiles;
    },
    ImportDocument(item) {
      this.importDocPopup = true;
      this.ImportData = item.summarizedText == '-' ? item.originalText : item.summarizedText;
    },
    Save() {
      if (!this.documentId) {
        this.$swal.fire({
          title: this.$t('_missingInformation'),
          text: this.$t('_pleaseFillAllFields'),
          icon: 'warning',
          confirmButtonText: this.$t('ok'),
        });
        return;
      }

      if (!this.request.filesList || this.request.filesList.length === 0) {
        this.$swal.fire({
          title: this.$t('_noFileSelected'),
          text: this.$t('_pleaseSelectAudioFile'),
          showCloseButton: true,
          focusConfirm: true,
          buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: this.$t("ok"),
          customClass: {
            popup: "swal-warning-popup",
            title: "swal-warning-title",
            htmlContainer: "swal-warning-body",
            actions: "swal-warning-actions",
            confirmButton: "swal-warning-confirm",
            closeButton: "swal-warning-close",
            },
        });
        return;
      }
      let formData = new FormData();
      this.request.dataName = this.documentId;
      this.Axios_ControllerAduio = new AbortController();

      let Config = {
        signal: this.Axios_ControllerAduio.signal,
      };

      this.request.filesList.forEach((file) => {
        formData.append(`FileSpeech`, file);
      });

      formData.append('LangPop', this.request.langPop);
      formData.append('dataName', this.request.dataName);
      formData.append('FileSpeech', this.request.filesList);
      if (this.modelDisplayID != 0 && this.botSummation) {
        formData.append('modelDisplay', this.modelDisplayID);
      }
      this.loading = true;
      try {
        this.$call.UploadSpeechDocument(
          formData,
          Config,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.loading = false;
              this.uploadDialog = false;
              this.processingDocId = this.documentId;
              this.processingStatus = { inProcess: 0, processFinish: 0, isDone: false };
              this.GetSpeechDocumentTable();
              this.GetSpeechDocumentDetail();
              if (this.pollingInterval) clearInterval(this.pollingInterval);
              this.StartProcessingStatusPoll();
            }
          },
          (errorResource) => {
            this.loading = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'Save');
      }
    },
    StartProcessingStatusPoll() {
      this.pollingInterval = setInterval(() => {
        this.$call.GetSpeechDocumentStatus(
          this.processingDocId,
          (statusResponse) => this.HandleProcessingStatusResponse(statusResponse),
          () => {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
            this.processingStatus = null;
          }
        );
      }, 3000);
    },
    HandleProcessingStatusResponse(statusResponse) {
      if (statusResponse.status == 0 && statusResponse.data) {
        this.processingStatus = {
          inProcess: statusResponse.data.inProcess,
          processFinish: statusResponse.data.processFinish,
          isDone: statusResponse.data.isDone,
        };
        if (statusResponse.data.isDone) {
          clearInterval(this.pollingInterval);
          this.pollingInterval = null;
          this.GetSpeechDocumentTable();
          this.GetSpeechDocumentDetail();
          setTimeout(() => {
            this.processingStatus = null;
          }, 3000);
        }
      }
    },
    SaveImport() {
      let temp = {
        vectordbName: this.DocId,
        modelType: 1,
        groupReplaceID: null,
        Content: this.ImportData,
        flagNew: false,
        customCharacter: null,
        DetectLanguage: true,
        MaxLimitedCharacter: this.maxLimitedCharacter,
      };
      this.dialog = true;
      try {
        this.$call.SaveAddVector(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = '✔ ' + this.$t('successfullyImported');
              this.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                backdrop: false,
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title',
                },
              });
              this.importDocPopup = false;
            }
          },
          (errorResource) => {
            this.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    GetSpeechDocumentDetail() {
      this.loading = true;
      if (this.isSearch) {
        this.options.page = 1;
        this.options.itemsPerPage = 10;
      }

      let { page, itemsPerPage } = this.options;
      this.sortBy = this.options.sortBy == undefined || this.options.sortBy.length == 0 ? null : this.options.sortBy[0];
      this.sortDesc = this.options.sortDesc == undefined || this.options.sortDesc.length == 0 ? null : this.options.sortDesc[0];

      const tempData = {
        page: page,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        id: this.documentId,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      };
      this.$call.GetSpeechDocumentDetail(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.speechDocumentDataDetail.data = dataResponse.data.data;
            this.documentName = dataResponse.data.documentName;
            if (this.speechDocumentDataDetail.data != 0) {
              this.speechDocumentDataDetail.total = dataResponse.data.total;
              this.speechDocumentDataDetail.data.forEach((item) => {
                item.summarizedText = item.summarizedText == null || item.summarizedText == '' ? '-' : item.summarizedText;
                item.show = this.ShowAllText;
              });
              this.searchDocName = this.documentName;
              this.AutoRefresh();
            }
            this.loading = false;
          }
        },
        (errorResource) => {
          this.loading = false;
          console.error(errorResource);
        }
      );
    },
    GetSpeechDocumentTable() {
      const { page, itemsPerPage } = this.options;
      this.sortBy = this.options.sortBy == undefined || this.options.sortBy.length == 0 ? null : this.options.sortBy[0];
      this.sortDesc = this.options.sortDesc == undefined || this.options.sortDesc.length == 0 ? null : this.options.sortDesc[0];
      const tempData = {
        page: page,
        perPage: itemsPerPage,
        documentName: this.searchDocName,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      };
      this.$call.GetSpeechDocument(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.speechDocumentData.data = dataResponse.data.data;
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    RefreshSpeechDocumentDetail() {
      const { page, itemsPerPage } = this.options;
      this.sortBy = this.options.sortBy == undefined || this.options.sortBy.length == 0 ? null : this.options.sortBy[0];
      this.sortDesc = this.options.sortDesc == undefined || this.options.sortDesc.length == 0 ? null : this.options.sortDesc[0];
      const tempData = {
        page: page,
        perPage: itemsPerPage,
        id: this.documentId,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      };
      this.$call.GetSpeechDocumentDetail(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.speechDocumentDataDetail.data = dataResponse.data.data;
            if (this.speechDocumentDataDetail.data != 0) {
              this.speechDocumentDataDetail.total = dataResponse.data.total;
              this.speechDocumentDataDetail.data.forEach((item) => {
                item.summarizedText = item.summarizedText == null ? '-' : item.summarizedText;
              });
            }
            this.GetSpeechDocumentTable();
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    EditSpeechDocumentDetail(item) {
      this.editDialog = true;
      this.edit = {
        id: item.id,
        originalText: item.originalText,
        summarizedText: item.summarizedText === '-' || item.summarizedText === ' ' ? null : item.summarizedText,
      };
    },
    EditSave() {
      this.editDialog = false;
      this.$call.EditSpeechDocumentDetail(
        this.edit,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            let msgSuccess = '✔ ' + this.$t('successfullyUpdated');
            this.$swal.fire({
              title: msgSuccess,
              showConfirmButton: false,
              timer: 1500,
              position: 'top',
              backdrop: false,
              customClass: {
                popup: 'success-banner',
                title: 'success-banner-title',
              },
            });
          }
          this.GetSpeechDocumentDetail();
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    SummarizedPopup(item) {
      this.SummarizedPreparePopup = true;
      this.SummarizedRow = {
        id: item.id,
        originalText: item.originalText,
        summarizedText: item.summarizedText,
        modelDisplayID: item.modelDisplayID,
      };
    },
    SummarizedDetail() {
      this.loading = true;
      this.$call.SummarizedSpeechDocumentDetail(
        this.SummarizedRow,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            let msgSuccess = '✔ ' + this.$t('successfullySummarized');
            this.$swal.fire({
              title: msgSuccess,
              showConfirmButton: false,
              timer: 1500,
              position: 'top',
              backdrop: false,
              customClass: {
                popup: 'success-banner',
                title: 'success-banner-title',
              },
            });
          }
          this.loading = false;
          this.SummarizedPreparePopup = false;
          this.GetSpeechDocumentDetail();
        },
        (errorResource) => {
          this.loading = false;
          this.SummarizedPreparePopup = false;
          console.error(errorResource);
        }
      );
    },
    DeleteById(id) {
      this.deleteItem = id;
      this.dialog_delete = true;
    },
    confirmDelete() {
      if (!this.deleteItem) return;
      const id = this.deleteItem;
      try {
        this.dialog_delete = false;
        this.dialog = true;

        this.$call.DeleteSpeechDocumentDetail(
          id,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = '✔ ' + this.$t('successfullyDeleted');
              this.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                allowOutsideClick: true,
                allowEscapeKey: true,
                allowEnterKey: true,
                backdrop: false,
                position: 'top',
                background: 'transparent',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title',
                },
              });
              if (this.speechDocumentDataDetail.data.length == 1 && this.options.page != 1) {
                this.options.page -= 1; //ถ้าลบข้อมูลสุดท้ายของหน้านั้นๆให้บังคับกลับไปหน้าก่อน
              }
              if (this.speechDocumentDataDetail.data.length == 1) {
                this.$router.push('/UploadSoundToDocument');
              }
              this.GetSpeechDocumentDetail();
            }
            this.loading = false;
          },
          (errorResource) => {
            this.loading = false;
            console.error(errorResource);
          }
        );
      } catch (error) { //NOSONAR
        this.dialog_delete = false;
        this.deleteItem = null;
      }
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    Search() {
      this.GetSpeechDocumentDetail();
    },
    getStyle(template) {
      return template == '-' ? { textAlign: 'center' } : { textAlign: 'left' }; //make "-" placeholder center when it's was used
    },
    getItemModelNameText(item) {
      if (this.modelDisplayID == 0) {
        this.modelDisplayID = 1;
      }
      return `${item.modelDisplayID}: ${item.name}`;
    },
    getItemModelNameID(item) {
      return item.modelDisplayID;
    },
    GetDDLVector() {
      this.$call.GetDDLVector(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDLVector = dataResponse.data;
          } else {
            this.listDDLVector = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    getDocName(item) {
      if (this.DocId == 0) this.DocId = item.id;
      return item.id;
    },
    getDocId(item) {
      return item.id;
    },
    formatText(text) {
      return text.replaceAll(' ', '&nbsp;');
    },

    async AutoRefresh() {
      let shouldContinue = true;
      do {
        // Check if we're still on the correct page
        if (globalThis.location.pathname !== '/UploadSoundToDocumentDetail') {
          break;
        }
        // Wait for data to be available
        if (!this.speechDocumentData.data || this.speechDocumentData.data.length === 0) {
          await new Promise((resolve) => setTimeout(resolve, 5000));
          continue;
        }
        shouldContinue = false;
        // Check if any document is still processing
        for (let doc of this.speechDocumentData.data) {
          // Continue refreshing ONLY if inProcess is less than processFinish (not complete yet)
          if (doc.inProcess < doc.processFinish) {
            this.RefreshSpeechDocumentDetail();
            shouldContinue = true;
            break;
          }
        }
        if (shouldContinue) {
          await new Promise((resolve) => setTimeout(resolve, 5000));
        }
      } while (shouldContinue);
    },
    async GetModel() {
      await this.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDModelDisplayName = dataResponse.data;
          } else {
            this.listDDModelDisplayName = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    GetMaxLimitedCharacter() {
      this.dialog = true;
      this.$call.GetMaxLimitedCharacter(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.maxLimitedCharacter = dataResponse.data;
          } else {
            this.maxLimitedCharacter = null;
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
  },
  beforeUnmount() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
    this.processingStatus = null;
  },
  mounted() {
    this.GetDate();
    this.GetModel();
    this.GetDDLVector();
    this.GetMaxLimitedCharacter();
    this.GetSpeechDocumentDetail();
    this.GetSpeechDocumentTable();
  },
};
</script>

<style scoped>
.processing-chip {
  font-weight: 600;
  font-size: 0.8rem;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.processing-chip--active {
  animation: chip-pulse 2s ease-in-out infinite;
}
@keyframes chip-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(255, 160, 0, 0.5); }
  50% { box-shadow: 0 0 0 7px rgba(255, 160, 0, 0); }
}

.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 0 !important;
  border: 1px solid #dcdcdc;
}

.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.v-overlay--active {
  z-index: 2000 !important;
}

.v-data-table th,
.v-data-table td {
  white-space: normal !important;
  overflow-wrap: break-word;
}

.text-container {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  min-height: 60px;
}

.text-content {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
  line-height: 1.5;
  color: #424242;
  font-size: 0.875rem;
}

.text-content-show {
  overflow: hidden;
  -webkit-box-orient: vertical;
  flex-grow: 1;
  white-space: normal;
  line-height: 1.6;
  color: #424242;
  font-size: 0.875rem;
}

.responsive-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
}

/* Header Section */
.header-section {
  background: white;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}

/* Document Showcase */
.document-showcase {
  padding: 1.5rem;
  color: #171717;
}
:deep(thead) {
  background-color: #ffe4e1 !important;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.document-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.document-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 0.75rem;
  backdrop-filter: blur(10px);
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.document-info {
  flex: 1;
}

.document-label {
  font-size: 0.875rem;
  opacity: 0.9;
  font-weight: 500;
  display: block;
  margin-bottom: 0.25rem;
}

.document-name {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  overflow-wrap: break-word;
}

/* Controls Row */
.controls-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2rem;
  padding: 1.25rem 2rem;
  background: #f8f9fa;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.toggle-section {
  display: flex;
  align-items: center;
}

.compact-toggle {
  background: #ededed;
  border-radius: 12px;
  padding: 0.25rem 0.75rem;
  border: 1px solid #e0e0e0a4;
  margin: 0;
  transform: scale(0.85);
}

.compact-toggle--active {
  background-color: #fff2f2 !important;
  border: 1px solid #fff2f2;
}

.toggle-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 0.8rem;
  color: #424242;
}

.add-btn-green {
  border-radius: 10px !important;
  font-weight: 600;
  text-transform: none;
  height: 44px;
  min-width: 120px;
  background: linear-gradient(135deg, #39843c 0%, #2e7d32 100%) !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
  color: white !important;
}

.add-btn-green:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
  background: linear-gradient(135deg, #66bb6a 0%, #4caf50 100%) !important;
}

.add-btn-green:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

.add-btn-green:disabled {
  opacity: 0.6;
  transform: none !important;
  box-shadow: none !important;
  background: #e0e0e0 !important;
}

/* Table Row Styling */
.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.table-row:hover {
  background: rgba(25, 118, 210, 0.02);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Number Cell */
.number-cell {
  text-align: center;
  padding: 1rem 0.5rem;
  width: 80px;
}

/* Text Cells */
.text-cell {
  padding: 1rem;
  vertical-align: top;
  position: relative;
}

.text-content-wrapper {
  flex: 1;
  border-radius: 8px;
  padding: 0.75rem;
  transition: all 0.2s ease;
}

/* Expand Button */
.expand-btn {
  background: transparent !important;
  border-radius: 12px !important;
  width: 32px !important;
  height: 32px !important;
  align-self: flex-start;
  margin-top: 0.5rem;
}

.expand-btn:hover {
  background: #fde4df !important;
  transform: scale(1.1);
}

/* Action Cell */
.action-cell {
  text-align: center;
  padding: 1rem 0.5rem;
  vertical-align: middle;
  width: 160px;
}

.action-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-group {
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 4px 6px;
  transition: all 0.2s ease;
  gap: 8px;
}

.summarize-btn {
  border-radius: 10px !important;
  color: #e77b00 !important;
}

.summarize-btn:hover {
  background: #a96500 !important;
  color: white !important;
  box-shadow: 0 6px 16px rgba(255, 152, 0, 0.4);
  transform: translateY(-1px);
}

/* Action Divider */
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
  align-self: center;
  border-radius: 1px;
  transition: background-color 0.2s ease;
}

/* Table Improvements */
:deep(.v-data-table-server) {
  border-radius: 0 0 16px 16px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table__wrapper) {
  border-radius: 0 0 16px 16px;
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

:deep(.v-data-table tbody tr:last-child td) {
  border-bottom: none;
}

/* Loading State */
:deep(.v-data-table--loading .v-data-table__wrapper) {
  opacity: 0.6;
}

/* Empty State */
:deep(.v-data-table-rows-no-data) {
  text-align: center;
  padding: 3rem;
  color: #757575;
  font-style: italic;
}

/* Custom Scrollbar */
:deep(.v-data-table__wrapper)::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Dialog Styles - อิงจาก UploadSoundToDocument */
.upload-dialog,
.edit-dialog,
.import-dialog,
.summarize-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 2rem;
  width: 100%;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 0.75rem;
  margin-right: 1rem;
  backdrop-filter: blur(10px);
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed rgba(255, 255, 255, 0.3);
}

.header-text .dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
  color: #171717;
}

.header-text .dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.9;
  margin: 0;
  color: #646464;
}

/* Dialog Content */
.dialog-content {
  padding: 2rem;
}

.input-group {
  margin-bottom: 1rem;
}

.input-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 400;
  color: #424242;
  margin-bottom: 0.5rem;
}

.modern-input {
  background: white;
}
.modern-input :deep(.v-field) {
  border-radius: 16px;
  transition: all 0.2s ease;
  position: relative;
}
.modern-input .v-field {
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.modern-input.input-disabled {
  opacity: 0.6;
}

/* Inline Switch Styles */
.inline-switch {
  margin: 15px 0 0 0;
  padding: 0.5rem 1rem;
  background: #ededed;
  border-radius: 12px;
  border: 1px solid rgba(25, 118, 210, 0.1);
  width: 100%;
}
.inline-switch-active {
  background: #fff2fc;
  border-radius: 12px;
  width: 100%;
  margin: 15px 0 0 0;
  padding: 0.5rem 1rem;
}
/* Close All Button */
.close-all-btn {
  text-transform: none !important;
  font-weight: 500;
  border-radius: 10px !important;
  min-width: 120px;
  height: 40px;
  transition: all 0.2s ease;
  margin-bottom: 1em;
}

.close-all-btn:hover {
  background-color: #f4eeec !important;
}
.inline-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 1rem;
  color: #424242;
}

.inline-switch :deep(.v-switch__track),
.inline-switch :deep(.v-switch__thumb) {
  transform: scale(0.85);
}

/* Upload Section */
.upload-section {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.upload-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.upload-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #424242;
}

.upload-area-card {
  border-radius: 12px;
  border: none;
  transition: all 0.3s ease;
  background: #fafafa;
}

.upload-area-card :deep(.v-card) {
  width: 100% !important;
  border: none !important;
}

.upload-area-card :deep(.v-card .v-card-text .v-icon) {
  color: rgba(0, 0, 0, 0.377) !important;
}

.upload-area-card.drag-over {
  border-color: #1976d2;
  background: rgba(25, 118, 210, 0.05);
  transform: scale(1.02);
}

.upload-help-text {
  display: flex;
  align-items: center;
  margin-top: 0.75rem;
  font-size: 0.8rem;
  color: #757575;
}

/* Info Card */
.info-card {
  border-radius: 12px;
  display: flex;
  align-items: flex-start;
  font-size: 0.875rem;
  color: #424242;
}

/* Dialog Actions */

.import-btn {
  border-radius: 10px;
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.import-btn:hover {
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
  transform: translateY(-1px);
}

.padding-btn {
  padding: 0 1.5rem;
}

/* Edit Dialog Specific */
.edit-dialog .header-icon-wrapper {
  background: rgba(255, 152, 0, 0.2);
}

.edit-icon {
  background: rgba(255, 255, 255, 0.2) !important;
}

/* Import Dialog Specific */
.import-icon {
  background: rgba(255, 255, 255, 0.2) !important;
}

/* Summarize Dialog Specific */
.summarize-icon {
  background: rgba(255, 255, 255, 0.2) !important;
}

/* Save Button */

/* Modern Textarea */
.modern-input .v-textarea :deep(.v-field__field) {
  min-height: 120px;
}

/* Custom Textarea Resize Handle */
.modern-input :deep(textarea) {
  resize: vertical;
}

.modern-input :deep(textarea::-webkit-resizer) {
  display: none;
}

.modern-input.v-textarea :deep(.v-field)::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 40px;
  height: 40px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40' fill='none'%3E%3Cpath d='M26.6667 30L30 26.6667M18.3333 30L30 18.3333M10 30L30 10' stroke='%23646464' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  pointer-events: none;
}

/* Disabled Input Style */
.modern-input:has(.v-field--disabled) {
  opacity: 0.7;
}

/* Transitions */
.v-dialog-transition-enter-active,
.v-dialog-transition-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.v-dialog-transition-enter-from {
  opacity: 0;
  transform: scale(0.9) translateY(20px);
}

.v-dialog-transition-leave-to {
  opacity: 0;
  transform: scale(0.9) translateY(-20px);
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-start .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
.custombtn {
  min-width: 100px;
}
:deep(.mdi-menu-down.mdi.v-icon.notranslate.v-theme--light.v-icon--size-default.v-select__menu-icon) {
  color: #872612;
  opacity: 1 !important;
}

.publication-toggle--active {
  background-color: #fff2f2 !important;
  border: 1px solid #fff2f2;
}

.publication-toggle--active :deep(.v-switch__track) {
  background-color: #ffffff !important;
  border: 1px solid #d32f2f;
}

.publication-toggle--active :deep(.v-switch__thumb) {
  background-color: #d32f2f !important;
  border: 1px solid #d32f2f;
  transform: translateX(-0.5px);
}

.publication-toggle--inactive :deep(.v-switch__track) {
  background-color: #bdbdbd !important;
}

.publication-toggle--inactive :deep(.v-switch__thumb) {
  background-color: #ffffff !important;
  width: 30px;
  height: 30px;
}
.publication-toggle {
  margin: 0 4px;
}

.publication-toggle :deep(.v-switch__track) {
  transform: scale(0.8);
  width: 40px;
  height: 28px;
  background-color: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle :deep(.v-switch__thumb) {
  width: 20px;
  height: 20px;
  box-shadow: none;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
:deep(.v-data-table-footer .v-field) {
  border-radius: 10px !important;
  width: 70px !important;
}
/* Responsive Design */
@media (max-width: 768px) {
  .document-showcase {
    padding: 1rem 1.5rem;
  }

  .document-header {
    flex-direction: column;
    text-align: center;
    gap: 0.75rem;
  }

  .document-name {
    font-size: 1.25rem;
  }

  .controls-row {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 1.5rem;
  }

  .toggle-section {
    width: 100%;
    justify-content: center;
  }

  .add-btn-green {
    width: 100%;
    max-width: 200px;
  }

  .action-group {
    flex-direction: column;
    gap: 2px;
    padding: 6px 4px;
  }

  .action-divider {
    width: 80%;
    height: 1px;
    margin: 2px 0;
  }

  .action-btn {
    width: 32px !important;
    height: 32px !important;
  }

  .text-container {
    flex-direction: column;
    gap: 0.5rem;
  }

  .expand-btn {
    align-self: center;
    margin-top: 0;
  }

  .header-content {
    padding: 1rem;
  }

  .dialog-content {
    padding: 1rem;
  }

  .dialog-actions {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
  }

  .actions-left,
  .actions-right {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .document-showcase {
    padding: 0.75rem 1rem;
  }

  .document-name {
    font-size: 1.1rem;
  }

  .controls-row {
    padding: 0.75rem 1rem;
  }

  .text-cell {
    padding: 0.5rem;
  }

  .text-content-wrapper {
    padding: 0.5rem;
  }

  .action-cell {
    padding: 0.5rem 0.25rem;
    width: 120px;
  }
}
.number-controls-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 100%;
}
.number-arrow-btn {
  width: 24px !important;
  height: 16px !important;
  min-width: unset !important;
  padding: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  transition: all 0.15s ease !important;
}

.number-arrow-btn:hover {
  background: rgba(56, 89, 208, 0.1) !important;
}

.number-arrow-btn:active {
  background: rgba(56, 89, 208, 0.2) !important;
  transform: scale(0.95);
}
.clear-btn-custom {
  width: 28px !important;
  height: 28px !important;
  border-radius: 50% !important;
  background: #757575 !important;
  color: white !important;
  transition: all 0.2s ease !important;
}

.clear-btn-custom:hover {
  background: rgba(102, 102, 102, 0.2) !important;
}
.number-arrows {
  margin-bottom: 10px;
}
</style>
